import React from 'react';
import { useAdminAuth, AdminAuthProvider } from '../context/AdminAuthContext';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';
import { Loader2 } from 'lucide-react';

const AdminContent = () => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <Loader2 size={32} className="animate-spin text-emerald-700" />
      </div>
    );
  }

  return admin ? <AdminDashboard /> : <AdminLogin />;
};

const AdminPage = () => {
  return (
    <AdminAuthProvider>
      <AdminContent />
    </AdminAuthProvider>
  );
};

export default AdminPage;
